import { isEmpty } from 'lodash'
import { useSignInUpOut } from 'hooks/user/useSignInUpOut'
import { useCallback, useEffect, useState } from 'react'
import isEmail from 'validator/lib/isEmail'
import { SingleDataLoader } from 'components/Atoms/SingleDataLoader'
import { config } from 'config/index'
import { SKINS } from 'constants/skins'
const { APP_SKIN_VERSION, WSB_REFERRAL_CODE } = config

const FORM_FIELD_INIT = {
  username: '',
  email: '',
  password: '',
}

const PASSWORD_VALID_REGEXP = /^.{6,}$/

export const SignUpForm = ({ referralCode, openSignInModal, onSignedUp }) => {
  const { state: signState, resetState: resetSignState, signUp } = useSignInUpOut({ onSignedUp })
  const [formFields, setFormFields] = useState(FORM_FIELD_INIT)
  const [errors, setErrors] = useState({})
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (isEmpty(referralCode)) return
    setFormFields({
      ...formFields,
      referralCode,
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (APP_SKIN_VERSION !== SKINS.WSB) return
    setFormFields({
      ...formFields,
      promotionalCode: WSB_REFERRAL_CODE,
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (!signState.isError) return
    setLoading(false)
  }, [signState])

  const onFieldChange = (event) => {
    const name = event.target.name
    const value = event.target.value
    setFormFields({
      ...formFields,
      [name]: value,
    })
    setErrors({ ...errors, [name]: false })
    resetSignState()
  }

  const onCheckField = (event) => {
    const name = event.target.name
    if (name === 'username' && !formFields.username) setErrors({ ...errors, username: 'This field is required' })

    if (name === 'email' && !isEmail(formFields.email)) {
      setErrors({ ...errors, email: 'Please enter a valid email address' })
      return
    }
    if (name === 'password' && !formFields.password) {
      setErrors({ ...errors, password: 'This field is required' })
      return
    }
    if (name === 'password' && !PASSWORD_VALID_REGEXP.test(formFields.password)) {
      setErrors({ ...errors, password: '6 minimum characters are needed' })
      return
    }
  }

  const onSubmit = () => {
    if (!formFields.username) {
      setErrors({ ...errors, username: 'This field is required' })
      return
    }
    if (!isEmail(formFields.email)) {
      setErrors({ ...errors, email: 'Please enter a valid email address' })
      return
    }
    if (!formFields.password) {
      setErrors({ ...errors, password: 'This field is required' })
      return
    }
    if (!PASSWORD_VALID_REGEXP.test(formFields.password)) {
      setErrors({ ...errors, password: '6 minimum characters are needed' })
      return
    }

    signUp(formFields)
    setLoading(true)
  }

  const onKeySubmit = (event) => {
    event.key === 'Enter' && onSubmit()
  }
  return (
    <>
      <div className='panel' id='register_one-panel'>
        <div className='signin_wrapper'>
          <form>
            <fieldset>
              <label htmlFor='username'>
                Username <span className='required_ast'>*</span>
              </label>
              <input
                type='text'
                name='username'
                placeholder='Username'
                value={formFields.username}
                onChange={onFieldChange}
                onKeyDown={onKeySubmit}
                onBlur={onCheckField}
              />
              {!!errors.username && <div className='field_error'>{errors.username}</div>}
              {!!signState.isError && (
                <div className='field_error'>This account already exist. Please try another.</div>
              )}
            </fieldset>
            <fieldset>
              <label htmlFor='email'>
                Email <span className='required_ast'>*</span>
              </label>
              <input
                type='text'
                name='email'
                placeholder='youremail@domain.com'
                value={formFields.email}
                onChange={onFieldChange}
                onKeyDown={onKeySubmit}
                onBlur={onCheckField}
              />
              {!!errors.email && <div className='field_error'>{errors.email}</div>}
            </fieldset>
            <fieldset>
              <label htmlFor='password'>
                Password <span className='required_ast'>*</span>
              </label>
              <input
                type='password'
                name='password'
                placeholder='********'
                value={formFields.password}
                onChange={onFieldChange}
                onKeyDown={onKeySubmit}
                onBlur={onCheckField}
              />
              {!!errors.password && <div className='field_error'>{errors.password}</div>}
            </fieldset>
            <fieldset>
              <label htmlFor='password'>Referral code</label>
              <input
                type='text'
                name={'referralCode'}
                value={formFields.referralCode}
                disabled={APP_SKIN_VERSION === SKINS.WSB}
                onChange={onFieldChange}
                onKeyDown={onKeySubmit}
                onBlur={onCheckField}
              />
              {!!errors.leverageBetaCode && <div className='field_error'>{errors.leverageBetaCode}</div>}
            </fieldset>
            {!!formFields.leverageBetaCode && (
              <fieldset>
                <label htmlFor='password'>FUTURE$ Beta code</label>
                <input
                  type='text'
                  name={'leverageBetaCode'}
                  value={formFields.leverageBetaCode}
                  disabled={true}
                  onChange={onFieldChange}
                  onKeyDown={onKeySubmit}
                  onBlur={onCheckField}
                />
                {!!errors.leverageBetaCode && <div className='field_error'>{errors.leverageBetaCode}</div>}
              </fieldset>
            )}
            <fieldset>
              <button type='button' onClick={onSubmit}>
                Start bidding
                <SingleDataLoader loading={loading} data={''} />
              </button>
            </fieldset>
          </form>
          <div className='user_alternate_access mobile'>
            <span>Already have an account?</span>
            <button onClick={openSignInModal}>Sign In</button>
          </div>
        </div>
      </div>
    </>
  )
}
